export const NOTIFICATION_WIDTH_TRESHOLD = 325;
export const NOTIFICATION_WIDTH_MAX = 325;
export const NOTIFICATION_WIDTH_ADJUSTMENT = 35;

export const NOTIFICATION_POPOVER_WIDTH_TRESHOLD = 390;
export const NOTIFICATION_POPOVER_WIDTH_MAX = 380;
export const NOTIFICATION_POPOVER_WIDTH_ADJUSTMENT = 10;

// Wrapper for window.matchMedia to make it easier to test
export const getMatchMedia = (query) => window.matchMedia(query).matches;

export const isXxs = getMatchMedia('(max-width: 575px)');
export const isXs = getMatchMedia('(max-width: 639px)');
export const isSm = getMatchMedia('(max-width: 767px)');
export const isMd = getMatchMedia('(max-width: 1023px)');
export const isLg = getMatchMedia('(max-width: 1279px)');
export const isXl = getMatchMedia('(max-width: 1535px)');
export const is2Xl = getMatchMedia('(min-width: 1536px)');
